import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
const faqs = [{
  q: 'Do I get the full prompts or just ideas?',
  a: 'The full prompts. All 120 are complete and ready to copy and paste. You only fill in the [brackets] with your own facts.'
}, {
  q: 'Is it allowed to use AI for reports at my agency?',
  a: 'Policies vary. Every volume reminds you to follow your agency’s policy on AI tools and on sharing inmate information. Many officers use the prompts with roles or initials, then add names and ID numbers in the official system.'
}, {
  q: 'Will the AI make things up?',
  a: 'Every prompt tells the AI to use only the facts you give it and to ask you when something is missing. You always review and sign your own report.'
}, {
  q: 'Does it work outside the US?',
  a: 'Yes. It is written for corrections staff in the US, Canada, the UK, Australia and New Zealand, and you can tell the AI your spelling and your agency’s terms (inmate, prisoner, detainee).'
}, {
  q: 'Do I need to be a tech expert?',
  a: 'No. If you can copy and paste, you can use this toolkit on your phone, tablet or computer.'
}, {
  q: 'Is it a one-time payment?',
  a: 'Yes. Pay once and keep the PDFs. No subscription.'
}];
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section aria-label="Frequently asked questions" className="bg-transparent" data-id="element-40" data-mp="11x8u9pn658mv">
      <div className="mx-auto max-w-3xl px-5 py-12" style={{
      paddingTop: "14px",
      paddingBottom: "14px"
    }} data-id="element-41" data-mp="11ve6m3kij2f3">
        <h2 className="text-center font-display text-3xl font-black text-plum sm:text-4xl" data-id="element-42" data-mp="16ps3kaetphlv">
          ❓ Frequently Asked Questions
        </h2>
        <div className="mt-10 divide-y divide-grape/10 overflow-hidden rounded-2xl border border-grape/15 bg-white" data-id="element-43" data-mp="wz798z66mz8r">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} data-id="element-44" data-mp="n07ztedlezkp" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left transition-colors duration-150 ease-out hover:bg-lilac-soft focus:outline-none focus-visible:bg-lilac-soft" data-id="element-45" data-mp="mzgfizpg4o9q">
                  <span className="text-sm font-bold text-plum sm:text-base" data-id="element-46" data-mp="2fxlpm8lurin8">{f.q}</span>
                  {isOpen ? <MinusIcon className="h-5 w-5 shrink-0 text-blush" data-id="element-47" data-mp="2az1yzuwbdioj" /> : <PlusIcon className="h-5 w-5 shrink-0 text-plum/40" data-id="element-48" data-mp="38l95xbg3bn42" />}
                </button>
                <div className="grid transition-[grid-template-rows] duration-300 ease-out" style={{
              gridTemplateRows: isOpen ? '1fr' : '0fr'
            }} data-id="element-49" data-mp="33mo3r6ha2tcz">
                  <div className="overflow-hidden" data-id="element-50" data-mp="2ylibtavfza4i">
                    <p className="px-6 pb-5 text-sm leading-relaxed text-plum/70" data-id="element-51" data-mp="2umhu5vopadj3">{f.a}</p>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}